<carm-forms-page
    [displayAlertsForPage]="inCmsContentPageId"
    inLocalizedPageTitle="{{ inIndexPage.localizationKey + '.title' | translate }}"
    inLocalizedPageShortDescription="{{ inIndexPage.localizationKey + '.description'| translate}}"
    [inBreadcrumbLevels]="inBreadcrumbLevels"
    [inHideTopTitleInfo]='hideTopTitleInfo'>
    <div class="row">
        <div class="col-sm-12">
            <h2>{{ 'application_features.sectionsHeader' | translate }}</h2>
        </div>
    </div>

    <div class="row gc-srvinfo">
        <ng-container *ngFor="let subSection of ((inIndexPage.sections | applyAcl) | async); let i = index">
            <div class="col-md-{{ columnValue }}" [ngClass]="{'clear-both': i % iValue ===0}">
                <carm-index-page-section
                    [inPath]="subSection.path"
                    [requestSource]="subSection.requestSource"
                    [inDataCy]="subSection.dataCy"
                    inLocalizedTitle="{{ inIndexPage.localizationKey + '.sections.' + subSection.localizationKey + '.title' | translate}} "
                    inLocalizedDescription="{{inIndexPage.localizationKey + '.sections.' + subSection.localizationKey + '.description' | translate}}">
                </carm-index-page-section>
            </div>
        </ng-container>
    </div>
</carm-forms-page>

